export const getRedactProps = () => {
    return {
        'data-private': true, // This is LogRocket's default, but keep in sync with our LR configs
    };
};
